import React from "react";
import { BrowserRouter as Brow, Switch, Route } from "react-router-dom";
import LandingPage from "../views/landing/index";
import LoginPage from "../views/auth/Login";
import RegisterPage from "../views/auth/Register";
import DashboardPage from "../views/admin/dashboard/home";
import ListArticlePage from "./admin/article/list";
import DetailArticlePage from "./admin/article/detail";
import CreateArticlePage from "./admin/article/add";
import UpdateArticlePage from "./admin/article/update";
import ListPsikologPage from "./admin/psikolog/List";
import DetailPsikologPage from "./admin/psikolog/Detail";
import ListTransasctionPage from "./admin/plan/List";
// import DetailTransactionPage from "./admin/plan/Detail";
import ProtectedRoute from "../components/ProtectedRoute";

export default function Router() {
  return (
    <Brow>
      <Switch>
        <Route exact path="/" component={LandingPage} />
        <Route path="/login" component={LoginPage} />
        <Route path="/register" component={RegisterPage} />
        <ProtectedRoute exact path="/dashboard" component={DashboardPage} />
        <ProtectedRoute
          exact
          path="/dashboard/article"
          component={ListArticlePage}
        />
        <Route
          exact
          path="/dashboard/article/:id"
          component={DetailArticlePage}
        />
        <ProtectedRoute
          exact
          path="/dashboard/article-add"
          component={CreateArticlePage}
        />
        <Route
          exact
          path="/dashboard/article-edit/:id"
          component={UpdateArticlePage}
        />
        <ProtectedRoute
          exact
          path="/dashboard/psikolog"
          component={ListPsikologPage}
        />
        <Route
          exact
          path="/dashboard/psikolog/:id"
          component={DetailPsikologPage}
        />
        <ProtectedRoute
          exact
          path="/dashboard/plan"
          component={ListTransasctionPage}
        />
        <Route
          exact
          path="/dashboard/psikolog/:id"
          component={DetailPsikologPage}
        />
      </Switch>
    </Brow>
  );
}
